import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { LOGIN_FORM_BG_COLOR } = constants;

let styles = {
  logo: {
    width: 160,
    margin: 30
  },
  p: {
    color: 'white'
  },
  form: {
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'column',
    alignItems: 'center',
    width: 470,
    backgroundColor: LOGIN_FORM_BG_COLOR,
    borderRadius: 5,
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
    padding: '20px 50px'
  },
  actions: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    padding: '85px 50px 30px',
    width: '100%'
  },
  actionsError: {
    paddingTop: 35
  },
  create: {
    marginLeft: 10,
    backgroundColor: `${LOGIN_FORM_BG_COLOR} !important`
  },
  separator: {
    height: 20
  },
  showPassword:{
    alignSelf: 'flex-start'
  }
};

export default StyleSheet.create(styles);


// WEBPACK FOOTER //
// ./src/components/forms/newuser/NewUserForm.styles.js